function PastEvents() {
  return <h2>Welcome to Past Events</h2>;
}
export default PastEvents;